export default {
  medium: '16px',
  small: '14px',
  tiny: '12px',
  desktop: {
    medium: '16px',
    small: '14px',
    tiny: '12px',
  },
  smallDevice: {
    medium: '15px',
  },
};



// WEBPACK FOOTER //
// ./src/components/SurveyToast/styles/constants/FontSize.js